var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.49 58.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bc6efe58-7617-44b5-9a48-7f319286af83,.bea52851-03b2-4efa-b7ee-ccf712c62ffb{fill:none;stroke:#1a1a1a;stroke-miterlimit:10;}.bc6efe58-7617-44b5-9a48-7f319286af83{stroke-width:1.27px;}.bea52851-03b2-4efa-b7ee-ccf712c62ffb{stroke-width:0.86px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b0f503d1-a1f7-497d-a34b-372d0ad3b0c5",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b6565f47-4454-48f3-8d33-28ccd3718be6",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "bc6efe58-7617-44b5-9a48-7f319286af83",
    cx: 29.24,
    cy: 29.24,
    r: 28.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "bea52851-03b2-4efa-b7ee-ccf712c62ffb",
    d: "M34.74,20.09a5.55,5.55,0,1,1-5.55-5.54,5.55,5.55,0,0,1,5.55,5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bea52851-03b2-4efa-b7ee-ccf712c62ffb",
    d: "M29,10.48h.15A10.72,10.72,0,0,1,39.68,21.16c0,7.09-7.58,14.28-10.59,16.85l-.66-.58h0c-3.33-3-9.92-9.65-9.92-16.26A10.73,10.73,0,0,1,29,10.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bea52851-03b2-4efa-b7ee-ccf712c62ffb",
    d: "M29.24,48c-6.34,0-12.77-1.82-12.77-5.3,0-2.44,3.16-4.06,7.24-4.82.79.8,1.54,1.5,2.19,2.08-4.44.5-7,1.9-7,2.74,0,1,3.94,2.92,10.39,2.92s10.4-1.89,10.4-2.92c0-.85-2.72-2.3-7.33-2.77.66-.58,1.41-1.29,2.21-2.09,4.2.73,7.5,2.37,7.5,4.86,0,3.48-6.43,5.3-12.78,5.3Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/address_icon.98b080481811a18213c04fc4ff9297b7.svg";
export { ForwardRef as ReactComponent };